import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { getUserInfo, updateNotification } from "../../services/account-setting.services";
import { SWAL_SETTINGS } from "../../../../utils/Constants";

export default function EditNotification() {
  const [pushEnabled, setPushEnabled] = useState(false);
  const [smsEnabled, setSmsEnabled] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUserPreferences = async () => {
      try {
        const response = await getUserInfo();
        const user = response.data;

        setPushEnabled(!!user?.wantPushNotification);
        setSmsEnabled(!!user?.wantTextMessage);
      } catch (error) {
        Swal.fire({
          icon: "error",
          text: "Failed to load notification preferences",
          ...SWAL_SETTINGS,
        });
      } finally {
        setLoading(false);
      }
    };

    fetchUserPreferences();
  }, []);

  const handleToggle = async (type) => {
    const newPush = type === "push" ? !pushEnabled : pushEnabled;
    const newSMS = type === "sms" ? !smsEnabled : smsEnabled;

    try {
      const response = await updateNotification({
        wantPushNotification: newPush,
        wantTextMessage: newSMS,
      });

      // Update local state after successful API call
      if (type === "push") setPushEnabled(newPush);
      if (type === "sms") setSmsEnabled(newSMS);

      Swal.fire({
        icon: "success",
        text: response.message || "Notification preferences updated",
        ...SWAL_SETTINGS,
      });
    } catch (error) {
      Swal.fire({
        icon: "error",
        text: error?.response?.data?.message || "Failed to update preferences",
        ...SWAL_SETTINGS,
      });
    }
  };

  if (loading) return <div>Loading...</div>;

  return (
    <div className="main-content">
      <div className="customer-part">
        <div className="card-box">
          <div className="notification">
            <h3 className="h3-headline text-center mb-5">Notifications Settings</h3>
            <ul className="notification-1">
              {/* // making borer rounded */}
              <li className="border py-2 px-3 d-flex justify-content-between rounded">
                <div className="notification-left">
                  <h6 className="h6-headline">Push Notifications</h6>
                </div>
                <div className="form-check form-switch">
                  <input className="form-check-input" type="checkbox" id="pushToggle" checked={pushEnabled} onChange={() => handleToggle("push")} />
                </div>
              </li>
              {/* <li className="border py-2 px-3 d-flex justify-content-between rounded">
                <div className="notification-left">
                  <h6 className="h6-headline">SMS (Text Messages)</h6>
                </div>
                <div className="form-check form-switch">
                  <input className="form-check-input" type="checkbox" id="smsToggle" checked={smsEnabled} onChange={() => handleToggle("sms")} />
                </div>
              </li> */}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
